/**
 * The S8 kinds of the S3 single dialog slot (`storageDialogStore.tsx`) and the options they carry. S8 dialogs share
 * S3's slot and its dirty / saving guard (Fable F8): a dialog with a draft or a request in flight is never replaced.
 */
import type { HnsPathRef, StorageAclChange } from '../../../../../types/azureStorage';

export type HnsDialogKind = 'hns-new-directory' | 'hns-move' | 'hns-acl' | 'hns-acl-propagate';
export const HNS_DIALOG_KINDS: readonly HnsDialogKind[] = ['hns-new-directory', 'hns-move', 'hns-acl', 'hns-acl-propagate'];
export const isHnsDialogKind = (kind: string): kind is HnsDialogKind => (HNS_DIALOG_KINDS as readonly string[]).includes(kind);

export type HnsActionSource = 'toolbar' | 'row-menu' | 'keyboard' | 'tree' | 'notice';

export type HnsDialogOptions = {
  /** `hns-move`: Rename (same parent, a name field) or Move (file system + path). */
  moveAction?: 'rename' | 'move';
  /** The listed row's ETag (Data Lake rows only); the Move dialog uses it only under `listedEtagEqualsHeadEtag` (8.0.3 / A6). */
  listedEtag?: string;
  /** Where the dialog was opened from (analytics `source`). */
  origin?: HnsActionSource;
  /** The tab whose requests the dialog tracks (closing the tab cancels them). */
  tabId?: string;
  /** Called with the created / moved path after the service confirmed it, so the tab can select it. */
  onDone?: (resource: HnsPathRef) => void;
  /** `hns-acl-propagate` opened by "Propagate again from this directory" (Transfers): the failed job's change, pre-filled. */
  propagateChange?: StorageAclChange;
};

/** Props every S8 hosted dialog receives from `HnsDialogHost`. */
export type HnsHostedDialogProps = {
  connectionId: string;
  resource: HnsPathRef;
  options: HnsDialogOptions;
  readOnly: boolean;
  onGuardChange: (guard: { dirty: boolean; saving: boolean }) => void;
  onClose: () => void;
};
